"use client";

import { SignupFormContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { SignUpTitle } from "@faire/retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import { useSignUpUPLT } from "@faire/retailer-visitor-shared/views/SignUp/_hooks/useSignUpUPLT";
import {
  BusinessTypeData,
  BusinessTypeForm,
  useSchema,
} from "@faire/retailer-visitor-shared/views/SignUp/business-type/__internal__/BusinessTypeForm";
import { useSignUpRequest } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { useSaveRequestAndGoToNextStep } from "@faire/retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { useSignUpPrefetchEffect } from "@faire/retailer-visitor-shared/views/SignUp/useSignUpPrefetchEffect";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Spacer } from "@faire/web/slate/spacing";
import { trackSignupSignUpFormStep2StoreInfoView } from "@faire/web-api--source/events/signup/view/signUpFormStep2StoreInfo";
import { Formik } from "formik";
import React, { useEffect } from "react";

export const BusinessTypeStep: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const schema = useSchema();
  const { saveAndGoToNextStep } = useSaveRequestAndGoToNextStep(
    Step.BUSINESS_TYPE
  );

  useSignUpPrefetchEffect(Step.BUSINESS_TYPE);

  useEffect(() => {
    trackSignupSignUpFormStep2StoreInfoView();
  }, []);
  useSignUpUPLT({ step: Step.BUSINESS_TYPE });

  const [{ user, reported_creation_time, ...initialValues }] = useSignUpRequest(
    [
      "business_platforms",
      "business_type",
      "other_business_platform_description",
      "reported_creation_time",
      "user",
    ]
  );

  const onNext = (values: BusinessTypeData) => {
    const business_platforms = [...values.business_platforms];
    saveAndGoToNextStep({
      business_platforms,
      business_type: values.business_type,
      other_business_platform_description:
        values.other_business_platform_description,
    });
  };

  return (
    <SignupFormContainer>
      <SignUpTitle
        title={strictLocalize(
          {
            defaultMessage:
              "Hi {firstPersonName}, where do you sell your products?",
            description: {
              img: "https://cdn.faire.com/fastly/ad198dddc3bd59e4a20e57d9e310dd467bfdb66e927024612a46f2d0d3406b27.png",
              text: "Business type step title for faire direct or widget",
            },
          },
          {
            firstPersonName: user?.first_name ?? "",
          }
        )}
      />
      <Spacer
        height={{
          mobileAndAbove: "4x",
          desktopAndAbove: "5x",
        }}
      />
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={onNext}
      >
        <BusinessTypeForm />
      </Formik>
    </SignupFormContainer>
  );
};
